import React from 'react'
import {GetRoomFilter} from '../../../hoteleria/features/room/models'
import {selectMapperByKeys} from '../../mappers/util'
import {useHoteleriaServices} from './useHoteleriaServices'

export const useRooms = () => {
  const [loading, setLoading] = React.useState(false)
  const [rooms, setRooms] = React.useState<{value: string; label: string}[]>([])
  const {getRooms} = useHoteleriaServices()

  const getRoomsFn = async (
    filters: GetRoomFilter,
    options: {all: boolean; value: any; label: string} = {all: false, value: null, label: 'TODOS'},
  ) => {
    try {
      setLoading(true)
      const rooms = await getRooms(filters)
      const mappedRooms = selectMapperByKeys(rooms, 'Id', 'Codigo')
      let filteredData = mappedRooms.filter((item) => item.value !== '4EsB2NAAsDA=')
      if (options.all && filteredData.length > 0) {
        filteredData = [{value: options.value, label: options.label}, ...filteredData]
        setRooms(filteredData)
        return filteredData
      } else {
        setRooms(filteredData)
        return filteredData
      }
    } catch (error) {
      console.error('Error fetching rooms:', error)
    } finally {
      setLoading(false)
    }
  }

  const clearRooms = () => {
    setRooms([])
  }

  return {
    loading,
    rooms,
    getRooms: getRoomsFn,
    clearRooms,
  }
}
